const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        appearances: {
            ghostAlt: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                brand: {
                    default: false,
                },
                brandAlt: {
                    default: false,
                },
                dark: {
                    default: false,
                },
                darkAlt: {
                    default: false,
                },
                shade: {
                    default: false,
                },
                neutral: {
                    default: false,
                },
                subtle: {
                    default: false,
                },
                flat: {
                    default: false,
                },
                flatAlt: {
                    default: false,
                },
                info: {
                    default: false,
                },
                basic: {
                    default: false,
                },
                slate: {
                    default: false,
                },
            },
            size: {
                xlarge: {
                    default: false,
                },
            },
            context: {
                minimum: {
                    default: false,
                },
                moderate: {
                    default: false,
                },
                overlay: {
                    default: false,
                },
                round: {
                    default: false,
                },
                square: {
                    default: false,
                },
                tablet: {
                    default: false,
                },
                roundTablet: {
                    default: false,
                },
            },
        },
    },
    appearances: {
        filled: {
            mapping: {
                textFontFamily: 'text-font-family',
                borderColor: 'transparent',
                textColor: '$color-text-basic',
                iconTintColor: '$color-text-basic',
                borderWidth: 1,
            },
            variantGroups: {
                status: {
                    primary: {
                        backgroundColor: '$color-primary-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-primary-400',
                            },
                            focused: {
                                backgroundColor: '$color-primary-600',
                            },
                            active: {
                                backgroundColor: '$color-primary-600',
                            },
                            disabled: {
                                backgroundColor: '$color-primary-transparent-300',
                            },
                        },
                    },
                    success: {
                        backgroundColor: '$color-success-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-success-600',
                            },
                            focused: {
                                backgroundColor: '$color-success-600',
                            },
                            active: {
                                backgroundColor: '$color-success-600',
                            },
                            disabled: {
                                backgroundColor: '$color-success-transparent-300',
                            },
                        },
                    },
                    warning: {
                        backgroundColor: '$color-warning-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-warning-600',
                            },
                            focused: {
                                backgroundColor: '$color-warning-600',
                            },
                            active: {
                                backgroundColor: '$color-warning-600',
                            },
                            disabled: {
                                backgroundColor: '$color-warning-transparent-300',
                            },
                        },
                    },
                    danger: {
                        backgroundColor: '$color-danger-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-danger-600',
                            },
                            focused: {
                                backgroundColor: '$color-danger-600',
                            },
                            active: {
                                backgroundColor: '$color-danger-600',
                            },
                            disabled: {
                                backgroundColor: '$color-danger-transparent-300',
                            },
                        },
                    },
                    dark: {
                        backgroundColor: '$color-dark-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-dark-400',
                            },
                            focused: {
                                backgroundColor: '$color-dark-600',
                            },
                            active: {
                                backgroundColor: '$color-dark-600',
                            },
                            disabled: {
                                backgroundColor: '$color-dark-300',
                            },
                        },
                    },
                    slate: {
                        backgroundColor: '$color-dark-200',
                        state: {
                            hover: {
                                backgroundColor: '$color-dark-100',
                            },
                            focused: {
                                backgroundColor: '$color-dark-500',
                            },
                            active: {
                                backgroundColor: '$color-dark-500',
                            },
                        },
                    },
                    shade: {
                        backgroundColor: '$color-dark-transparent-700',
                        state: {
                            hover: {
                                backgroundColor: '$color-dark-transparent-600',
                            },
                            focused: {
                                backgroundColor: '$color-dark-transparent-500',
                            },
                            active: {
                                backgroundColor: '$color-dark-transparent-500',
                            },
                            disabled: {
                                backgroundColor: '$color-dark-transparent-400',
                            },
                        },
                    },
                    neutral: {
                        backgroundColor: '$color-neutral-400',
                        state: {
                            hover: {
                                backgroundColor: '$color-neutral-500',
                            },
                            focused: {
                                backgroundColor: '$color-neutral-600',
                            },
                            active: {
                                backgroundColor: '$color-neutral-600',
                            },
                            disabled: {
                                backgroundColor: '$color-neutral-300',
                            },
                        },
                    },
                    subtle: {
                        backgroundColor: '$color-subtle-200',
                        textColor: '$color-subtle-600',
                        state: {
                            hover: {
                                backgroundColor: '$color-subtle-100',
                            },
                            focused: {
                                backgroundColor: '$color-subtle-300',
                            },
                            active: {
                                backgroundColor: '$color-subtle-300',
                            },
                            disabled: {
                                backgroundColor: '$color-subtle-100',
                                textColor: '$color-subtle-300',
                            },
                        },
                    },
                    brand: {
                        backgroundColor: '$color-brand-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-brand-400',
                            },
                            focused: {
                                backgroundColor: '$color-brand-600',
                            },
                            active: {
                                backgroundColor: '$color-brand-600',
                            },
                            disabled: {
                                backgroundColor: '$color-brand-300',
                            },
                        },
                    },
                    brandAlt: {
                        backgroundColor: '$color-brand-450',
                        state: {
                            hover: {
                                backgroundColor: '$color-brand-400',
                            },
                            focused: {
                                backgroundColor: '$color-brand-600',
                            },
                            active: {
                                backgroundColor: '$color-brand-600',
                            },
                            disabled: {
                                backgroundColor: '$color-brand-300',
                            },
                        },
                    },
                    flat: {
                        backgroundColor: '$color-flat-200',
                        textColor: '$color-flat-900',
                        iconTintColor: '$color-flat-900',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-400',
                            },
                            focused: {
                                backgroundColor: '$color-flat-400',
                            },
                            active: {
                                backgroundColor: '$color-flat-300',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-200',
                                iconTintColor: '$color-flat-400',
                            },
                        },
                    },
                    flatAlt: {
                        backgroundColor: '$color-flat-200',
                        textColor: '$color-flat-500',
                        iconTintColor: '$color-flat-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-200',
                            },
                            focused: {
                                backgroundColor: '$color-flat-200',
                            },
                            active: {
                                backgroundColor: '$color-flat-200',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-200',
                                iconTintColor: '$color-flat-200',
                            },
                        },
                    },
                    info: {
                        backgroundColor: '$color-flat-400',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-500',
                            },
                            focused: {
                                backgroundColor: '$color-flat-500',
                            },
                            active: {
                                backgroundColor: '$color-flat-500',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-200',
                                iconTintColor: '$color-flat-400',
                            },
                        },
                    },
                },
                size: {
                    text: {
                        textFontSize: 15,
                        borderRadius: 0,
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        iconMarginHorizontal: 0,
                        textMarginHorizontal: 0,
                    },
                    tiny: {
                        minWidth: 'size-tiny',
                        minHeight: 'size-tiny',
                        borderRadius: '$button-border-round',
                        borderWidth: 'border-width',
                        paddingHorizontal: 12,
                        paddingVertical: 4,
                        textMarginHorizontal: 6,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 12,
                        iconHeight: 12,
                        // iconMarginHorizontal: 6
                        iconMarginHorizontal: 0,
                    },
                    small: {
                        minWidth: 'size-small',
                        minHeight: 'size-small',
                        borderRadius: '$button-border-round',
                        borderWidth: 'border-width',
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        textMarginHorizontal: 8,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 16,
                        iconHeight: 16,
                        // iconMarginHorizontal: 8
                        iconMarginHorizontal: 0,
                    },
                    medium: {
                        minWidth: 'size-medium',
                        minHeight: 'size-medium',
                        borderRadius: '$button-border-round',
                        borderWidth: 'border-width',
                        paddingHorizontal: 20,
                        paddingVertical: 12,
                        textMarginHorizontal: 10,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 20,
                        iconHeight: 20,
                        // iconMarginHorizontal: 10
                        iconMarginHorizontal: 0,
                    },
                    large: {
                        minWidth: 'size-large',
                        minHeight: 'size-large',
                        borderRadius: '$button-border-round',
                        borderWidth: 'border-width',
                        paddingHorizontal: 24,
                        paddingVertical: 14,
                        textMarginHorizontal: 10,
                        textFontSize: 16,
                        textFontWeight: 'bold',
                        iconWidth: 24,
                        iconHeight: 24,
                        // iconMarginHorizontal: 10
                        iconMarginHorizontal: 0,
                    },
                    xlarge: {
                        minWidth: 'size-large',
                        minHeight: 'size-large',
                        borderRadius: '$button-border-round',
                        borderWidth: 'border-width',
                        paddingHorizontal: 28,
                        paddingVertical: 18,
                        textMarginHorizontal: 14,
                        textFontSize: 20,
                        textFontWeight: 'bold',
                        iconWidth: 28,
                        iconHeight: 28,
                        // iconMarginHorizontal: 10
                        iconMarginHorizontal: 0,
                    },
                },
                context: {
                    minimum: {
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        iconMarginHorizontal: 0,
                        textMarginHorizontal: 0,
                        minWidth: 0,
                        minHeight: 25,
                    },
                    moderate: {
                        paddingVertical: 8,
                        paddingHorizontal: 5,
                        iconMarginHorizontal: 0,
                        textMarginHorizontal: 0,
                        minWidth: 0,
                        minHeight: 25,
                    },
                    overlay: {
                        paddingVertical: 3.5,
                        paddingHorizontal: 4,
                        iconMarginHorizontal: 0,
                        textMarginHorizontal: 0,
                        minWidth: 0,
                        borderRadius: 4,
                        borderWidth: 1,
                        borderColor: 'rgba(255, 255, 255, 0.24)',
                        backgroundColor: '$dark-transparent-1000',
                        minHeight: 25,
                    },
                    round: {
                        paddingHorizontal: 14,
                        paddingVertical: 14,
                    },
                    square: {
                        borderRadius: 4,
                        textFontWeight: '400',
                        paddingHorizontal: 0,
                        paddingVertical: 0,
                        minWidth: 32,
                        minHeight: 32,
                    },
                    tablet: {
                        minWidth: 48,
                        minHeight: 48,
                        paddingHorizontal: 0,
                        paddingVertical: 0,
                        textMarginHorizontal: 2,
                    },
                    roundTablet: {
                        paddingHorizontal: 0,
                        paddingVertical: 0,
                        minWidth: 48,
                        minHeight: 48,
                    },
                },
            },
        },
        outline: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        borderColor: '$color-primary-500',
                        textColor: '$color-primary-500',
                        iconTintColor: '$color-primary-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-primary-400',
                                textColor: '$color-primary-400',
                                iconTintColor: '$color-primary-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-primary-600',
                                textColor: '$color-primary-600',
                                iconTintColor: '$color-primary-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-primary-600',
                                textColor: '$color-primary-600',
                                iconTintColor: '$color-primary-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-primary-transparent-300',
                                textColor: '$color-primary-300',
                                iconTintColor: '$color-primary-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    success: {
                        borderColor: '$color-success-500',
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-success-400',
                                textColor: '$color-success-400',
                                iconTintColor: '$color-success-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-success-600',
                                textColor: '$color-success-600',
                                iconTintColor: '$color-success-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-success-600',
                                textColor: '$color-success-600',
                                iconTintColor: '$color-success-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-success-transparent-300',
                                textColor: '$color-success-transparent-300',
                                iconTintColor: '$color-success-transparent-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    warning: {
                        borderColor: '$color-warning-500',
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-warning-400',
                                textColor: '$color-warning-400',
                                iconTintColor: '$color-warning-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-warning-600',
                                textColor: '$color-warning-600',
                                iconTintColor: '$color-warning-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-warning-600',
                                textColor: '$color-warning-600',
                                iconTintColor: '$color-warning-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-warning-transparent-300',
                                textColor: '$color-warning-transparent-300',
                                iconTintColor: '$color-warning-transparent-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    danger: {
                        borderColor: '$color-danger-500',
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-danger-400',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-danger-600',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-danger-600',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-danger-transparent-300',
                                textColor: '$color-danger-transparent-300',
                                iconTintColor: '$color-danger-transparent-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    dark: {
                        borderColor: '$color-dark-500',
                        textColor: '$color-dark-500',
                        iconTintColor: '$color-dark-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-dark-400',
                                textColor: '$color-dark-400',
                                iconTintColor: '$color-dark-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-dark-600',
                                textColor: '$color-dark-600',
                                iconTintColor: '$color-dark-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-dark-600',
                                textColor: '$color-dark-600',
                                iconTintColor: '$color-dark-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-dark-300',
                                textColor: '$color-dark-300',
                                iconTintColor: '$color-dark-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    neutral: {
                        borderColor: '$color-neutral-400',
                        textColor: '$color-neutral-400',
                        iconTintColor: '$color-neutral-400',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-neutral-500',
                                textColor: '$color-neutral-500',
                                iconTintColor: '$color-neutral-500',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-neutral-700',
                                textColor: '$color-neutral-700',
                                iconTintColor: '$color-neutral-700',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-neutral-700',
                                textColor: '$color-neutral-700',
                                iconTintColor: '$color-neutral-700',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-neutral-300',
                                textColor: '$color-neutral-300',
                                iconTintColor: '$color-neutral-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    subtle: {
                        borderColor: '$color-subtle-500',
                        textColor: '$color-subtle-500',
                        iconTintColor: '$color-subtle-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-subtle-400',
                                textColor: '$color-subtle-400',
                                iconTintColor: '$color-subtle-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-subtle-600',
                                textColor: '$color-subtle-600',
                                iconTintColor: '$color-subtle-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-subtle-600',
                                textColor: '$color-subtle-600',
                                iconTintColor: '$color-subtle-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-subtle-300',
                                textColor: '$color-subtle-300',
                                iconTintColor: '$color-subtle-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    brand: {
                        borderColor: '$color-brand-500',
                        textColor: '$color-brand-500',
                        iconTintColor: '$color-brand-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-brand-400',
                                textColor: '$color-brand-400',
                                iconTintColor: '$color-brand-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-brand-600',
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-brand-600',
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-brand-300',
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    brandAlt: {
                        borderColor: '$color-brand-450',
                        textColor: '$color-brand-450',
                        iconTintColor: '$color-brand-450',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-brand-400',
                                textColor: '$color-brand-400',
                                iconTintColor: '$color-brand-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-brand-600',
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-brand-600',
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-brand-300',
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    info: {
                        borderColor: '$color-flat-400',
                        textColor: '$color-flat-700',
                        iconTintColor: '$color-flat-700',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-flat-400',
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                borderColor: '$color-flat-400',
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                borderColor: '$color-flat-400',
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                borderColor: '$color-flat-300',
                                textColor: '$color-flat-400',
                                iconTintColor: '$color-flat-400',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                },
            },
        },
        ghost: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-primary-500',
                        iconTintColor: '$color-primary-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-primary-400',
                                iconTintColor: '$color-primary-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-primary-600',
                                iconTintColor: '$color-primary-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-primary-600',
                                iconTintColor: '$color-primary-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-primary-300',
                                iconTintColor: '$color-primary-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    success: {
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-success-400',
                                iconTintColor: '$color-success-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-success-600',
                                iconTintColor: '$color-success-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-success-600',
                                iconTintColor: '$color-success-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-success-transparent-300',
                                iconTintColor: '$color-success-transparent-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    warning: {
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-warning-400',
                                iconTintColor: '$color-warning-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-warning-600',
                                iconTintColor: '$color-warning-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-warning-600',
                                iconTintColor: '$color-warning-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-warning-transparent-300',
                                iconTintColor: '$color-warning-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    danger: {
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-danger-400',
                                iconTintColor: '$color-danger-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-danger-600',
                                iconTintColor: '$color-danger-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-danger-600',
                                iconTintColor: '$color-danger-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-danger-transparent-300',
                                iconTintColor: '$color-danger-transparent-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    dark: {
                        textColor: '$color-dark-500',
                        iconTintColor: '$color-dark-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-dark-400',
                                iconTintColor: '$color-dark-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-dark-600',
                                iconTintColor: '$color-dark-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-dark-600',
                                iconTintColor: '$color-dark-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-dark-300',
                                iconTintColor: '$color-dark-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    darkAlt: {
                        textColor: 'white',
                        iconTintColor: 'rgba(0, 0, 0, 0.64)',
                        backgroundColor: 'rgba(0, 0, 0, 0.64)',
                    },
                    neutral: {
                        textColor: '$color-neutral-400',
                        iconTintColor: '$color-neutral-400',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-neutral-500',
                                iconTintColor: '$color-neutral-500',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-neutral-700',
                                iconTintColor: '$color-neutral-700',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-neutral-700',
                                iconTintColor: '$color-neutral-700',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-flat-400',
                                iconTintColor: '$color-flat-400',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    subtle: {
                        textColor: '$color-subtle-500',
                        iconTintColor: '$color-subtle-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-subtle-400',
                                iconTintColor: '$color-subtle-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-subtle-600',
                                iconTintColor: '$color-subtle-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-subtle-600',
                                iconTintColor: '$color-subtle-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-subtle-300',
                                iconTintColor: '$color-subtle-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    brand: {
                        textColor: '$color-brand-500',
                        iconTintColor: '$color-brand-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand-400',
                                iconTintColor: '$color-brand-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    brandAlt: {
                        textColor: '$color-brand-450',
                        iconTintColor: '$color-brand-450',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand-400',
                                iconTintColor: '$color-brand-400',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-brand-600',
                                iconTintColor: '$color-brand-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    info: {
                        textColor: '$color-flat-700',
                        iconTintColor: '$color-flat-700',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-neutral-300',
                                iconTintColor: '$color-neutral-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                    basic: {
                        backgroundColor: '$color-flat-100',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-200',
                            },
                            focused: {
                                backgroundColor: '$color-flat-200',
                            },
                            active: {
                                backgroundColor: '$color-flat-200',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-400',
                                iconTintColor: '$colot-flat-400',
                            },
                        },
                    },
                    flat: {
                        textColor: '$color-flat-400',
                        iconTintColor: '$color-flat-400',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            focused: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            active: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-neutral-300',
                                iconTintColor: '$color-neutral-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                },
                context: {
                    overlay: {
                        backgroundColor: '$color-dark-transparent-1000',
                        state: {
                            hover: {
                                backgroundColor: '$color-dark-transparent-600',
                            },
                            focused: {
                                backgroundColor: '$color-dark-transparent-500',
                            },
                            active: {
                                backgroundColor: '$color-dark-transparent-500',
                            },
                            disabled: {
                                backgroundColor: '$color-dark-transparent-400',
                            },
                        },
                    },
                },
            },
        },
        ghostAlt: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-primary-500',
                        iconTintColor: '$color-primary-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-primary-500',
                                iconTintColor: '$color-primary-500',
                                backgroundColor: '$color-primary-300',
                            },
                            focused: {
                                textColor: '$color-primary-500',
                                iconTintColor: '$color-primary-500',
                                backgroundColor: '$color-primary-400',
                            },
                            active: {
                                textColor: '$color-primary-500',
                                iconTintColor: '$color-primary-500',
                                backgroundColor: '$color-primary-400',
                            },
                            disabled: {
                                textColor: '$color-primary-500',
                                iconTintColor: '$color-primary-500',
                                backgroundColor: '$color-primary-200',
                            },
                        },
                    },
                    success: {
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-300',
                            },
                            focused: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-400',
                            },
                            active: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-400',
                            },
                            disabled: {
                                textColor: '$color-success-transparent-300',
                                iconTintColor: '$color-success-transparent-300',
                                backgroundColor: '$color-success-200',
                            },
                        },
                    },
                    warning: {
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-warning-400',
                                iconTintColor: '$color-warning-400',
                                backgroundColor: '$color-warning-300',
                            },
                            focused: {
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-400',
                            },
                            active: {
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-400',
                            },
                            disabled: {
                                textColor: '$color-warning-transparent-300',
                                iconTintColor: '$color-warning-300',
                                backgroundColor: '$color-warning-200',
                            },
                        },
                    },
                    danger: {
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-danger-400',
                                iconTintColor: '$color-danger-400',
                                backgroundColor: '$color-danger-300',
                            },
                            focused: {
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-400',
                            },
                            active: {
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-400',
                            },
                            disabled: {
                                textColor: '$color-danger-transparent-300',
                                iconTintColor: '$color-danger-transparent-300',
                                backgroundColor: '$color-danger-200',
                            },
                        },
                    },
                    dark: {
                        textColor: '$color-dark-500',
                        iconTintColor: '$color-dark-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-dark-500',
                                iconTintColor: '$color-dark-400',
                                backgroundColor: '$color-dark-300',
                            },
                            focused: {
                                textColor: '$color-dark-500',
                                iconTintColor: '$color-dark-500',
                                backgroundColor: '$color-dark-400',
                            },
                            active: {
                                textColor: '$color-dark-500',
                                iconTintColor: '$color-dark-500',
                                backgroundColor: '$color-dark-400',
                            },
                            disabled: {
                                textColor: '$color-dark-300',
                                iconTintColor: '$color-dark-300',
                                backgroundColor: '$color-dark-200',
                            },
                        },
                    },
                    // [TODO] This needs some work
                    neutral: {
                        textColor: '$color-neutral-400',
                        iconTintColor: '$color-neutral-400',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-neutral-500',
                                iconTintColor: '$color-neutral-500',
                                backgroundColor: '$color-neutral-300',
                            },
                            focused: {
                                textColor: '$color-neutral-600',
                                iconTintColor: '$color-neutral-600',
                                backgroundColor: '$color-neutral-300',
                            },
                            active: {
                                textColor: '$color-neutral-500',
                                iconTintColor: '$color-neutral-500',
                                backgroundColor: '$color-neutral-400',
                            },
                            disabled: {
                                textColor: '$color-neutral-300',
                                iconTintColor: '$color-neutral-300',
                                backgroundColor: '$color-neutral-200',
                            },
                        },
                    },
                    subtle: {
                        textColor: '$color-subtle-500',
                        iconTintColor: '$color-subtle-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-subtle-500',
                                iconTintColor: '$color-subtle-500',
                                backgroundColor: '$color-subtle-300',
                            },
                            focused: {
                                textColor: '$color-subtle-500',
                                iconTintColor: '$color-subtle-500',
                                backgroundColor: '$color-subtle-400',
                            },
                            active: {
                                textColor: '$color-subtle-500',
                                iconTintColor: '$color-subtle-500',
                                backgroundColor: '$color-subtle-400',
                            },
                            disabled: {
                                textColor: '$color-subtle-100',
                                iconTintColor: '$color-subtle-300',
                                backgroundColor: '$color-subtle-200',
                            },
                        },
                    },
                    brand: {
                        textColor: '$color-brand-500',
                        iconTintColor: '$color-brand-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-300',
                            },
                            focused: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-400',
                            },
                            active: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-400',
                            },
                            disabled: {
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: '$color-brand-200',
                            },
                        },
                    },
                    subtleAlt: {
                        backgroundColor: '$color-flat-200',
                        textColor: '$color-flat-500',
                        iconTintColor: '$color-flat-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-200',
                            },
                            focused: {
                                backgroundColor: '$color-flat-200',
                            },
                            active: {
                                backgroundColor: '$color-flat-200',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-200',
                                iconTintColor: '$color-flat-200',
                            },
                        },
                    },
                },
            },
        },
        outlineAlt: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-primary-500',
                        iconTintColor: '$color-primary-500',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: '$color-primary-300',
                            },
                            focused: {
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: '$color-primary-400',
                            },
                            active: {
                                textColor: '$color-flat-500',
                                iconTintColor: '$color-flat-500',
                                backgroundColor: '$color-primary-400',
                            },
                            disabled: {
                                textColor: '$color-primary-500',
                                iconTintColor: '$color-primary-500',
                                backgroundColor: '$color-primary-200',
                            },
                        },
                    },
                    flatAlt: {
                        backgroundColor: '$color-flat-200',
                        textColor: '$color-flat-500',
                        iconTintColor: '$color-flat-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-flat-200',
                            },
                            focused: {
                                backgroundColor: '$color-flat-200',
                            },
                            active: {
                                backgroundColor: '$color-flat-200',
                            },
                            disabled: {
                                backgroundColor: '$color-flat-200',
                                iconTintColor: '$color-flat-200',
                            },
                        },
                    },
                    brandAlt: {
                        textColor: '$color-brand-450',
                        iconTintColor: '$color-brand-450',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-300',
                            },
                            focused: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-400',
                            },
                            active: {
                                textColor: '$color-brand-500',
                                iconTintColor: '$color-brand-500',
                                backgroundColor: '$color-brand-400',
                            },
                            disabled: {
                                textColor: '$color-brand-300',
                                iconTintColor: '$color-brand-300',
                                backgroundColor: '$color-brand-200',
                            },
                        },
                    },
                    info: {
                        textColor: '$color-flat-700',
                        iconTintColor: '$color-flat-700',
                        backgroundColor: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: '$color-flat-200',
                            },
                            focused: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: '$color-flat-200',
                            },
                            active: {
                                textColor: '$color-flat-600',
                                iconTintColor: '$color-flat-600',
                                backgroundColor: '$color-flat-200',
                            },
                            disabled: {
                                textColor: '$color-neutral-300',
                                iconTintColor: '$color-neutral-300',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAButton.theme.alucio.js.map